import { css } from 'styled-components'

export const styles = css`
  input#date-picker-input-fake:not([disabled]) {
    background-color: transparent !important;
    border: none;
    text-align: center;
    padding: 0;
    height: fit-content;
    cursor: pointer;
    color: var(--blue-light);
    font-size: var(--text-1);

    &::placeholder {
      color: var(--blue-light);
      font-size: var(--text-1);
    }
  }
`

export const datePickerModal = css`
  #date-picker-modal {
    background-color: var(--gray-100) !important;
  }

  #date-picker-modal-backdrop {
    opacity: 0 !important;
  }

  .hot-form__input {
    border: 0.063rem solid var(--gray-200) !important;
    background-color: transparent !important;
  }

  .hot-button {
    background-color: inherit !important;
    color: var(--gray-500) !important;
  }

  .hot-button.hot-button--primary {
    color: var(--gray-500) !important;
  }

  .flatpickr-disabled {
    color: var(--gray-500) !important;
  }
`
